// @flow
import * as React from 'react';
import compose from 'recompose/compose';
import { useTranslation } from 'react-i18next';

import IconChildrenAdd from 'app/components/_Icons/IconChildrenAdd';
import config from 'app/config.js';
import AddChild, { withChildAddPermission } from 'app/components/AddChild';
import withToggle from 'app/common/containers/withToggle';

import styles from './Empty.scss';


type Props = {
  handleToggle: (e: SyntheticEvent<HTMLElement>) => void,
  isOpen: boolean,
  enableChildAdd: boolean,
}

const enhance = compose(
  withToggle(),
  withChildAddPermission
);

const Empty = enhance(({ handleToggle, isOpen, enableChildAdd }: Props) => {
  const { t } = useTranslation('children');

  return (
    <div className={styles.root}>
      <div className={styles.infobox}>
        <div className={styles.h1}>
          {t('no_children')}
        </div>
        <div className={styles.text}>
          {enableChildAdd
            ? t('no_children_comment_to_add')
            : t('no_children_comment')}
        </div>
        {enableChildAdd
          && <div className={styles.link}>
            <a href="addChild" onClick={handleToggle}>
              {t('add_child_bt')}
            </a>
          </div>}
        <div className={styles.iconBlock}>
          {enableChildAdd
            ? <a href="addChild" onClick={handleToggle}>
              <IconChildrenAdd
                colorFront={config.primaryColor}
                colorBack={config.faintColor}
                class={styles.icon}
              />
            </a>
            : <IconChildrenAdd
              colorFront={config.primaryColor}
              colorBack={config.faintColor}
              class={styles.icon}
            />}
        </div>
      </div>
      <AddChild isOpen={isOpen} onClose={handleToggle} />
    </div>
  );
});

export default Empty;
